import {
  ModalService,
  NotificationService,
  addNavMenuSection,
  registerBulkAction,
} from '@vendure/admin-ui/core';

import { REDIRECT_LIST_LOCATION_ID } from './redirect-list.component';
import { RedirectsDataService } from './redirects-data.service';

export default [
  addNavMenuSection(
    {
      id: 'redirects',
      label: 'Redirects',
      items: [
        {
          id: 'redirect-list',
          label: 'Redirects',
          routerLink: ['/extensions/redirects'],
          // Icon can be any of https://core.clarity.design/foundation/icons/shapes/
          icon: 'two-way-arrows',
        },
      ],
    },
    // Add this section before the "settings" section
    'settings',
  ),
  registerBulkAction({
    location: REDIRECT_LIST_LOCATION_ID,
    label: 'Delete',
    icon: 'trash',

    onClick: ({ injector, selection, clearSelection }) => {
      const modalService = injector.get(ModalService);
      const redirectDataService = injector.get(RedirectsDataService);
      const notificationService = injector.get(NotificationService);

      modalService
        .dialog({
          title: `Delete ${selection.length} redirects?`,
          buttons: [
            { type: 'secondary', label: 'cancel' },
            { type: 'primary', label: 'delete', returnValue: true },
          ],
        })
        .subscribe((response) => {
          if (response) {
            const ids = selection.map((item) => item.id);
            try {
              redirectDataService.deleteRedirects(ids);
              notificationService.success('redirects.delete-success');
            } catch (e) {
              notificationService.error('redirects.error.delete-failed');
            } finally {
              clearSelection();
            }
          }
        });
    },
  }),
];
